<template>
  <div
    class="user-view"
    v-if="hasAdminRole"
  >
    <!-- add a navagation bar here to navigate between the UserList and the Permissions Page-->
    <div class="user-view__user-form">
      <span @click="e => show != show">
        <span class="user-view__collapse-btn">
          <collapse-arrows
            :down="!show"
            @click.native="e => (show = !show)"
          />
          <h4 class="user-view__form_label">Create User Form</h4>
        </span>
      </span>
      <user-form v-if="show" />
    </div>
    <div class="user-view__user-list">
      <user-list
        :copiedUserList="copiedUserList"
        :rolesList="rolesList"
      >
      </user-list>
    </div>
    <action-modal
      buttonText="Delete"
      :object="userToDelete"
      @click="deleteUser()"
      ref="deleteUserModal"
    >
      Are you sure you want to delete user
      <span class="delete-target-modal__delete-target-name">
        {{ this.userToDelete.first_name }} {{ this.userToDelete.last_name }}
      </span>
    </action-modal>
  </div>
</template>

<script>
  import UserList from '@/appComponents/permissions/components/UserList'
  import UserForm from '@/appComponents/permissions/forms/UserForm'
  import { ActionModal } from '@/components/common/modal'
  import PermissionsAPI from '@/api/PermissionsAPI'
  import { SET_USERS, SET_ROLES } from '@/appLogic/permissions/store/constants'
  import CollapseArrows from '@/components/common/icons/CollapseArrows'
  import Toast from '@/components/common/toasts'
  import { cloneDeep } from 'lodash'

  export default {
    components: {
      UserList,
      UserForm,
      CollapseArrows,
      ActionModal,
    },
    data() {
      return {
        show: true,
        userToDelete: {
          first_name: '',
          last_name: '',
        },
      }
    },
    beforeMount() {
      this.setUsers()
      this.setRoles()
    },
    computed: {
      usersList() {
        return this.$store.state.permissions.users
      },
      rolesList() {
        return this.$store.state.permissions.roles
      },
      copiedUserList() {
        return cloneDeep(this.usersList)
      },
      hasAdminRole() {
        let r = this.$store.getters.userRoles
        return r && r.hasAdminRole()
      },
      showDeleteUserModal() {
        return this.$store.state.permissions.showDeleteUserModal
      },
    },
    methods: {
      setUsers() {
        if (this.usersList && this.usersList.length === 0) {
          this.$store.dispatch(SET_USERS)
        }
      },
      setRoles() {
        if (this.rolesList && this.rolesList.length === 0) {
          this.$store.dispatch(SET_ROLES)
        }
      },
      setUserToDelete(user) {
        this.userToDelete = user
      },
      deleteUser() {
        PermissionsAPI.deleteUser(this.userToDelete.id)
          .then(resp => {
            Toast.success({
              title: 'User Deleted:',
              message: `${this.userToDelete.first_name} ${this.userToDelete.last_name} has been successfully deleted`,
            })
            this.$store.dispatch(SET_USERS)
          })
          .catch(err => {
            console.log('error in UserList.vue, handleUserRemoval method', err)
            Toast.error({
              title: 'User Delete Error',
              message: 'There was an error in deleting this user, please refresh and try again',
            })
          })
          .finally(() => {
            this.userToDelete = {
              first_name: '',
              last_name: '',
            }
          })
      },
    },
    watch: {
      showDeleteUserModal(value) {
        if (value) {
          this.$refs.deleteUserModal.open()
        }
      },
    },
  }
</script>

<style lang="scss">
  .user-view {
    display: flex;
    width: 100%;
    height: 100%;

    margin-top: 3em;
    &__user-form {
      margin: 10px;
    }
    &__collapse-btn {
      display: flex;
    }
    &__form_label {
      margin: 0px;
      margin-left: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// UsersView.vue?2804064f